import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";

export const leftSideBarRoutes = [
  {
    href: "/dashboard",
    title: "Dashboard",
    icon: <PhotoCameraOutlinedIcon />,
  },
  {
    href: "/dashboard/events",
    title: "My Events",
    icon: <CalendarTodayOutlinedIcon sx={{ fontSize: 23 }} />,
  },
  {
    href: "/dashboard/contacts",
    title: "Contacts",
    icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 28, marginLeft: -0.2 }} />,
  },
  {
    href: "/dashboard/galleries",
    title: "Galleries",
    icon: <CollectionsOutlinedIcon />,
  },
  {
    href: "/dashboard/earnings",
    title: "Earnings",
    icon: <AccountBalanceWalletOutlinedIcon />,
  },
  {
    href: "/dashboard/notifications",
    title: "Notifications",
    icon: <NotificationsNoneOutlinedIcon />,
  },
];

export const photoppzLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="53"
    viewBox="0 0 60 53"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5723 52.0976C17.2198 52.4871 16.6433 52.5346 12.3993 52.5229C6.61903 52.5071 5.81561 52.2842 3.40409 50.0283C1.77599 48.5055 0.713434 46.7228 0.259197 44.7533C0.105616 44.0867 0.00406219 38.2539 0.000310221 29.889C-0.00494253 18.2397 0.0538384 15.8927 0.38226 14.631C1.15466 11.6647 3.15371 9.24796 5.89665 7.96454C7.19683 7.35622 7.99225 7.17212 9.87198 7.04556L12.2217 6.88697L13.7057 4.51073C15.2883 1.9769 16.637 0.703486 18.1976 0.270009C19.5633 -0.109189 40.536 -0.0804249 41.8142 0.302526C43.2802 0.741756 44.7312 2.18476 46.2683 4.73109L47.644 7.01029L49.1656 7.01129C54.2309 7.01404 58.1725 9.75597 59.5285 14.2196C60.024 15.8514 60.0387 16.3967 59.9707 30.5324L59.9004 45.157L59.1278 46.7874C58.1535 48.8437 56.332 50.7257 54.3975 51.6747L52.8968 52.4108L38.9159 52.4796C26.1165 52.5424 24.8958 52.5129 24.4709 52.1282C23.8873 51.5999 23.8763 50.7462 24.4444 50.0676C24.8773 49.5506 25.0334 49.5438 38.5215 49.477L52.1609 49.4092L53.402 48.7704C54.0886 48.4167 55.0064 47.6551 55.4561 47.0653C57.0414 44.9872 57.0517 44.8661 56.9714 29.2384L56.8988 15.1413L56.1485 13.7746C55.3135 12.2533 53.7439 10.9186 52.3277 10.5254C51.8152 10.3831 50.2619 10.266 48.8759 10.2652C45.8578 10.2635 45.9856 10.3598 43.8868 6.51178C43.0986 5.06727 42.2149 3.69105 41.9225 3.45343C41.4368 3.05847 40.4277 3.0207 30.2311 3.0157C19.5616 3.01019 19.0445 3.03145 18.4547 3.4952C18.1155 3.76209 17.1961 5.15307 16.4112 6.58657C14.3999 10.2605 14.4944 10.1967 10.8748 10.3128C7.39743 10.4243 6.39816 10.7995 4.89287 12.5579C3.25326 14.4734 3.24576 14.5515 3.24576 29.774C3.24576 44.9964 3.25326 45.0745 4.89287 46.9902C6.44193 48.7997 7.36692 49.1301 11.1874 49.2389L14.5017 49.3334V38.9503C14.5017 26.9975 14.619 25.9182 16.2863 22.5202C18.1896 18.6416 22.1129 15.3769 26.3829 14.1188C28.526 13.4874 32.3643 13.5432 34.5121 14.2371C38.9162 15.6598 42.4518 18.7249 44.385 22.7955C47.2763 28.8837 46.0897 35.2933 41.1701 40.1636C38.8501 42.4606 36.9764 43.5554 34.1129 44.2878C30.7822 45.1398 26.3509 44.8456 25.3248 43.7045C24.5209 42.8105 24.4744 42.3465 25.114 41.6029L25.7025 40.9185L27.4857 41.2244C32.1566 42.0254 35.719 41.0379 38.8169 38.0831C44.1637 32.9831 43.5836 24.1007 37.612 19.6341C35.5147 18.0653 33.8423 17.4835 30.994 17.3322C28.3937 17.1941 26.683 17.5393 24.5176 18.6391C21.9791 19.9288 19.6451 22.7125 18.6638 25.6208C18.1773 27.0635 18.1438 27.8237 18.059 39.4035C17.98 50.1589 17.9204 51.7129 17.5723 52.0976Z"
      fill="#D77171"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.033 35.0692C31.0792 36.066 28.3535 35.8574 26.6274 34.5787C22.9197 31.8323 23.2191 26.6296 27.2272 24.1515C28.286 23.4969 28.6867 23.3956 30.2203 23.3956C31.6983 23.3956 32.1828 23.5084 33.1525 24.0787C34.481 24.8596 35.5263 26.0052 36.0668 27.2727C36.5486 28.4023 36.5453 30.6527 36.0603 31.7933C35.5265 33.0484 34.2176 34.4649 33.033 35.0692ZM28.864 32.8491C29.713 33.1595 31.2771 33.0014 32.0555 32.5269C33.7246 31.5094 34.2886 29.6131 33.4489 27.8437C32.8851 26.6556 31.7823 26.0243 30.2693 26.023C28.1569 26.0215 26.6129 27.4945 26.6129 29.5116C26.6129 30.782 27.7267 32.4334 28.864 32.8491Z"
      fill="#4C8577"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M50.9379 18.2296C50.2628 19.0273 49.3429 19.1371 48.5509 18.514C46.8913 17.2086 48.4889 14.6663 50.3606 15.634C51.4587 16.2018 51.7073 17.3204 50.9379 18.2296Z"
      fill="#4C8577"
    />
  </svg>
);

export const photoppzTitle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="20"
    viewBox="0 0 150 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M69.8407 19.6407H65.4451V4.01204H60.5612V0.593262H74.7247V4.01204H69.8407V19.6407Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M92.0198 18.534C89.9388 19.7223 85.3303 20.0089 83.0275 19.0937C79.6722 17.7594 77.9604 14.515 77.9975 9.56066C78.04 3.94898 81.2497 0.589294 86.6304 0.525314C88.1005 0.507731 90.0814 0.749978 91.0333 1.06451C97.3409 3.14605 98.0164 15.1098 92.0198 18.534ZM85.6428 16.3601C88.4526 16.8759 90.5703 15.5684 91.3249 12.852C92.3676 9.09766 91.5226 5.36583 89.3781 4.25717C87.3527 3.20955 85.7283 3.34825 84.1537 4.70258C82.8526 5.8215 82.7833 6.09011 82.7833 10.0237C82.7833 14.4842 83.448 15.9567 85.6428 16.3601Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M105.494 19.6407H101.098V0.593262L104.883 0.596198C111.691 0.601082 113.773 1.78642 114.166 5.88017C114.577 10.1492 112.019 12.8032 107.496 12.8032H105.494V19.6407ZM105.845 9.57341C106.273 10.0008 108.423 9.50554 109.3 8.77685C109.687 8.45646 109.88 7.4611 109.792 6.25232C109.647 4.28017 109.621 4.25477 107.569 4.1063L105.494 3.95588V6.58882C105.494 8.03692 105.652 9.38001 105.845 9.57341Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M123.076 19.6407H118.681V0.593262L122.71 0.621104C129.537 0.667501 131.949 2.24161 131.949 6.6489C131.949 9.78197 130.375 11.8254 127.507 12.5297C126.77 12.7109 125.948 12.8032 125.045 12.8032H123.076V19.6407ZM123.428 9.57341C124.451 10.5961 127.96 8.30359 127.96 6.61227C127.96 4.89116 126.964 4.01204 125.013 4.01204H123.076V6.61716C123.076 8.04963 123.234 9.38001 123.428 9.57341Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M149.847 18.0535L150 19.6407H135.286L135.3 18.2977C135.309 17.4117 136.722 14.9673 139.452 11.1172C141.727 7.90603 143.589 5.003 143.589 4.66552C143.589 4.23378 142.394 4.00961 139.56 3.90997L135.53 3.76784L135.225 0.593262H149.45V1.85821C149.45 2.65576 147.916 5.30727 145.298 9.03716C143.015 12.2899 141.147 15.2291 141.147 15.568C141.147 16.0061 142.381 16.2249 145.42 16.325L149.694 16.4662L149.847 18.0535Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.9481 18.534C51.5454 19.335 50.2589 19.6217 48.1071 19.6139C41.9034 19.5904 38.9892 16.5365 38.9623 10.031C38.9457 5.99392 40.3293 3.11776 43.015 1.60861C44.7049 0.659168 45.5484 0.517521 48.6072 0.672343C54.5622 0.972707 56.8982 3.56561 56.8982 9.87277C56.8982 14.4046 55.7427 16.9379 52.9481 18.534ZM46.5711 16.3601C50.7552 17.1284 53.4184 13.3394 52.5031 7.92064C52.0416 5.18855 50.9197 4.00176 48.4919 3.676C46.6673 3.43131 46.2775 3.56855 44.9051 4.94143C43.3989 6.44765 43.3691 6.56486 43.5396 10.325C43.7266 14.4398 44.4998 15.9797 46.5711 16.3601Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.0805 15.6115L21.9384 19.6407H18.0708V0.593262H21.9355L22.2222 7.67502L26.0072 7.81763L29.7923 7.96025V0.593262H33.6995V19.6407H29.8319L29.5481 11.5822H22.2222L22.0805 15.6115Z"
      fill="#2F242C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.49569 16.3441L4.35113 19.6407H0V0.593262L3.78507 0.596198C5.86711 0.597663 8.35598 0.816946 9.31617 1.08361C12.8419 2.06334 14.4756 5.5461 13.0314 9.00346C12.0815 11.2765 10.4185 12.3421 7.20923 12.7338L4.63977 13.0474L4.49569 16.3441ZM4.72133 9.54754C5.16528 9.99149 5.57065 9.95925 7.16234 9.35412C8.79701 8.73239 9.26245 8.08772 9.27222 6.42961C9.28247 4.70117 8.42192 4.01204 6.25148 4.01204H4.39557V6.61716C4.39557 8.04963 4.54209 9.3683 4.72133 9.54754Z"
      fill="#2F242C"
    />
  </svg>
);

export const stripLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="236"
    height="119"
    viewBox="0 0 236 119"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M199.709 61.6979C199.709 50.1241 194.104 40.9889 183.385 40.9889C172.628 40.9889 166.114 50.1221 166.114 61.6055C166.114 75.2148 173.8 82.0864 184.831 82.0864C190.212 82.0864 194.281 80.867 197.354 79.1482V70.1054C194.281 71.6434 190.754 72.5913 186.278 72.5913C181.893 72.5913 178.004 71.0534 177.507 65.7198H199.612C199.612 65.1298 199.703 62.7816 199.703 61.696L199.709 61.6979ZM177.393 57.4047C177.393 52.2953 180.512 50.1713 183.362 50.1713C186.119 50.1713 189.059 52.2953 189.059 57.4047H177.393ZM148.685 40.9929C144.254 40.9929 141.409 43.0716 139.824 44.5191L139.234 41.7166H129.268V94.4331L140.571 92.0377L140.616 79.2426C142.245 80.4186 144.64 82.0903 148.62 82.0903C156.713 82.0903 164.082 75.6003 164.082 61.2476C164.037 48.1358 156.578 40.9909 148.664 40.9909L148.685 40.9929ZM145.971 72.1449C143.305 72.1449 141.723 71.195 140.636 70.0209L140.591 53.2452C141.767 51.9334 143.393 51.0307 145.971 51.0307C150.086 51.0307 152.933 55.6426 152.933 61.5642C152.933 67.6215 150.131 72.1449 145.971 72.1449ZM113.718 38.3261L125.066 35.8874V26.7109L113.718 29.1063V38.3261ZM113.718 41.7618H125.066V81.3213H113.718V41.7618ZM101.554 45.1052L100.83 41.7618H91.064V81.3253H102.366V54.5117C105.033 51.0307 109.555 51.664 110.957 52.1616V41.7638C109.509 41.221 104.221 40.2259 101.552 45.1071L101.554 45.1052ZM78.9494 31.9285L67.9183 34.2826L67.8731 70.4968C67.8731 77.1874 72.892 82.1159 79.5826 82.1159C83.2898 82.1159 86.0018 81.4374 87.4945 80.6212V71.4428C86.047 72.0328 78.9041 74.1096 78.9041 67.419V51.3926H87.4945V41.7618H78.9002L78.9494 31.9285ZM48.3874 53.2236C48.3874 51.4595 49.8348 50.7849 52.2302 50.7849C56.1402 50.8682 59.9776 51.8578 63.4402 53.6759V43.0736C59.6878 41.5789 55.9807 40.9948 52.2302 40.9948C43.0518 40.9948 36.9492 45.7876 36.9492 53.79C36.9492 66.2685 54.13 64.2782 54.13 69.661C54.13 71.7397 52.3207 72.4182 49.7896 72.4182C46.0372 72.4182 41.2444 70.8803 37.4468 68.7996V79.5572C41.6515 81.3666 45.9035 82.1139 49.7896 82.1139C59.1942 82.1139 65.6606 77.4568 65.6606 69.364C65.6154 55.8923 48.3874 58.2877 48.3874 53.2236Z"
      fill="white"
    />
  </svg>
);

export const completedLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
  >
    <path
      d="M58.6673 30.0597V32.513C58.664 38.2634 56.802 43.8588 53.3589 48.4645C49.9158 53.0702 45.0761 56.4396 39.5616 58.07C34.0471 59.7005 28.1533 59.5047 22.7592 57.5119C17.3651 55.519 12.7597 51.8359 9.62988 47.0118C6.50003 42.1877 5.01343 36.4812 5.39179 30.7432C5.77015 25.0052 7.9932 19.5432 11.7294 15.1718C15.4656 10.8005 20.5147 7.754 26.1238 6.48671C31.7329 5.21941 37.6014 5.79922 42.854 8.13965"
      stroke="#4C8577"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M58.6667 11.1797L32 37.873L24 29.873"
      stroke="#4C8577"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const stripLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M13.5 10.5996V15.0996C13.5 15.4974 13.342 15.879 13.0607 16.1603C12.7794 16.4416 12.3978 16.5996 12 16.5996H3.75C3.35218 16.5996 2.97064 16.4416 2.68934 16.1603C2.40804 15.879 2.25 15.4974 2.25 15.0996V6.84961C2.25 6.45178 2.40804 6.07025 2.68934 5.78895C2.97064 5.50764 3.35218 5.34961 3.75 5.34961H8.25"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 3.09961H15.75V7.59961"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 11.3496L15.75 3.09961"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
